import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { PropostaParaContrato } from '@/types/contrato';

interface ContratoSelecaoProps {
  propostasDisponiveis: PropostaParaContrato[];
  onSelecionarProposta: (proposta: PropostaParaContrato) => void;
}

export default function ContratoSelecao({ 
  propostasDisponiveis, 
  onSelecionarProposta 
}: ContratoSelecaoProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Selecionar Cliente para Contrato</CardTitle>
        <CardDescription>
          Escolha um cliente que já possui proposta aceita e ainda não possui contrato gerado
        </CardDescription>
      </CardHeader>
      <CardContent>
        {propostasDisponiveis.length === 0 ? (
          <Alert>
            <AlertDescription>
              Nenhuma proposta aceita pronta para contrato encontrada. 
              Certifique-se de que:
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>As propostas foram geradas na página de Propostas</li>
                <li>A proposta foi marcada como aceita pelo cliente na aba Contratos dos detalhes do lead</li>
                <li>O cliente ainda não possui contrato criado</li>
              </ul>
            </AlertDescription>
          </Alert>
        ) : (
          <div className="space-y-4">
            <div>
              <Label htmlFor="cliente-select">Selecionar Cliente</Label>
              <Select onValueChange={(value) => {
                const proposta = propostasDisponiveis.find(p => p.id === value);
                if (proposta) {
                  onSelecionarProposta(proposta);
                }
              }}>
                <SelectTrigger>
                  <SelectValue placeholder="Escolha um cliente..." />
                </SelectTrigger>
                <SelectContent>
                  {propostasDisponiveis.map((proposta) => (
                    <SelectItem key={proposta.id} value={proposta.id}>
                      <div className="flex flex-col">
                        <span className="font-semibold">
                          {proposta.lead_tipo === 'PF' ? proposta.lead_nome : proposta.lead_razao_social}
                          {proposta.dimensionamento_nome && (
                            <span className="text-blue-600 ml-2">
                              - {proposta.dimensionamento_nome}
                            </span>
                          )}
                        </span>
                        <span className="text-sm text-muted-foreground">
                          {proposta.lead_tipo === 'PF' ? 'Pessoa Física' : 'Pessoa Jurídica'} • 
                          Sistema: {proposta.potencia_total_paineis} kWp • 
                          Valor: R$ {(proposta.valor_total_kits + proposta.preco_integracao).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                        </span>
                      </div>
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
